import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { PatientRow } from "@/lib/database.types";

export function usePatient(userId: string | undefined) {
  return useQuery<PatientRow | null>({
    queryKey: ["patient", userId],
    enabled: !!userId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("patients")
        .select("*")
        .eq("user_id", userId!)
        .maybeSingle();
      if (error) throw error;
      return (data as PatientRow | null) ?? null;
    },
  });
}
